import { render, staticRenderFns } from "./apprMain.vue?vue&type=template&id=cd97d194&scoped=true&"
import script from "./apprMain.vue?vue&type=script&lang=js&"
export * from "./apprMain.vue?vue&type=script&lang=js&"
import style0 from "./apprMain.vue?vue&type=style&index=0&id=cd97d194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd97d194",
  null
  
)

export default component.exports